import { Box } from "@mantine/core"
import { Loader } from "@tfg/ui"

/** Reserved height for supplier route Suspense fallbacks (stateful-loading-and-error-states). */
export const SUPPLIER_ROUTE_FALLBACK_MIN_HEIGHT_PX = 240

export const SupplierPortalRouteFallback = () => (
  <Box mih={SUPPLIER_ROUTE_FALLBACK_MIN_HEIGHT_PX}>
    <Loader fullPage />
  </Box>
)
